<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Get Student / Employee</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @click="putnull()"
            persistent-hint hint="Please Select Academic Year" />
        </v-col>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="type" return-object :items="type_list"
            item-text="type" label="Select Type" outlined @click="putnull()" persistent-hint
            hint="Please Select Type" />
        </v-col>
        <v-col sm="2" v-if="sel_ay_data">
          <v-btn class="mt-6 button" @click="getData()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>
      <v-col cols="12" sm="12" md="12" v-if="learner_list != '' && type.type == 'Student'">
        <!-- <download-excel class="mar" :data="learner_list" :fields="table_fields" 
                    worksheet="Student_List" 
                    name="Student_List.xls">
                
                    <v-btn color="success" dark class="" outlined rounded>
                        
                        <v-icon dark>mdi-file-excel</v-icon> Export
                    </v-btn>
                </download-excel> -->

        <!-- <v-btn color="success" dark class="exportbtn" outlined rounded>
          <download-excel
            class="mar"
            :data="learner_list"
            :fields="table_fields"
            worksheet="Student_List"
            name="Student_List.xls"
          >
            <v-icon dark>mdi-file-excel</v-icon> Export
          </download-excel>
        </v-btn> -->
        <v-btn class="ma-2 no-display " rounded color="success" outlined
          @click="fnExcelReport('my-table-id', 'GetEmployeeStudent')" :loading="loader"><v-icon
            color="success">mdi-export</v-icon>Export</v-btn>

        <br />
        <div id="my-table-id">
          <v-data-table dense :headers="headers2" v-if="learner_list != ''" :items="learner_list" sort-by
            class="elevation-1 mytable" :search="search"></v-data-table>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="12" v-if="inst_list != '' && type.type == 'Employee'">
        <!-- {{inst_list}} -->
        <!-- <download-excel class="mar" :data="inst_list" :fields="table_fields2" 
                worksheet="Inst_List" name="Inst_List.xls">
                    
                    
                    
                    <v-btn color="success" dark class="" outlined rounded>
                        <v-icon dark>mdi-file-excel</v-icon> Export
                        </v-btn>
                </download-excel> -->

        <!-- <v-btn color="success" dark class="exportbtn" outlined rounded>
          <download-excel
            class="mar"
            :data="inst_list"
            :fields="table_fields2"
            worksheet="Inst_List"
            name="Inst_List.xls"
          >
            <v-icon dark>mdi-file-excel</v-icon> Export
          </download-excel>
        </v-btn> -->
        <v-btn class="ma-2 no-display " rounded color="success" outlined
          @click="fnExcelReport('my-table-id', 'GetEmployeeStudent')" :loading="loader"><v-icon
            color="success">mdi-export</v-icon>Export</v-btn>


        <br />
        <div id="my-table-id">
          <v-data-table dense :headers="headers" v-if="inst_list != ''" :items="inst_list" sort-by
            class="elevation-1 mytable" :search="search"></v-data-table>
        </div>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      file: null,
      statuslist: "",
      load: false,
      // extraBreadcrumbItems: [
        

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      loading3: false,
      search: "",
      learner_list: [],
      inst_list: [],
      ay_std_div_list: null,
      sel_ay_data: null,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      fetch_loader: false,
      type_list: [
        { id: 1, type: "Student" },
        { id: 2, type: "Employee" },
      ],
      type: null,
      table_fields: {
        "Sr. No": "srno",
        "PRN. No.": "reg_no",
        "Student Name": "name",
        Email: "email",
        "Contact number": "contact",
        Standard: "standard",
        Division: "division",
      },
      table_fields2: {
        "Sr. No": "srno",
        "Employee Code": "emp_code",
        "Employee Name": "name",
        Email: "email",
        "Contact number": "contact",
        "Instructor Type": "inst_type",
      },
      headers2: [
        { text: "Sr.NO", value: "srno" },
        { text: "PRN No.", value: "reg_no" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Contact number", value: "contact" },
        { text: "Standard", value: "standard" },
        { text: "Division", value: "division" },
        { text: "Quota", value: "quota" },
      ],
      headers: [
        { text: "Sr.NO", value: "srno" },
        { text: "Employee Code", value: "emp_code" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Contact number", value: "contact" },
        { text: "Instructor Type", value: "inst_type" },
      ],
      output_load: false,
    };
  },
  mounted() {
    axios
      .post("/commonAPI/get_ay_std_div")
      .then((res) => {
        this.ay_std_div_list = res.data.data;
        this.sel_ay_data = res.data.curr_ay;
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      })
      .finally(() => {});
  },
  methods: {
      fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                 const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    putnull() {
      (this.learner_list = []), (this.inst_list = []);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getData() {
      let ay;
      if (this.sel_ay_data.ay_id) {
        ay = this.sel_ay_data.ay_id;
      } else if (this.sel_ay_data.id) {
        ay = this.sel_ay_data.id;
      }
      const formData = {
        ay: ay,
        type: this.type.type,
      };
      this.fetch_loader = true;
      axios
        .post("/RoleManagement/getLearnerData", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.learner_list = res.data.learner_list;
            this.inst_list = res.data.inst_list;
            this.fetch_loader = false;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.fetch_loader = false;
        })
        .finally(() => {
          this.fetch_loader = false;
          //this.type = null
        });
    },
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}

.exportbtn {
  margin-bottom: 10px;
}
</style>
